import type { SpreadReadingProfile } from "../types";

export const psychologicalCircleReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_psychological_circle",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
  ],
};

